module.exports = __webpack_public_path__ + "img/72.14bf811c.webp";